import { api } from './api'
import { User } from '@stores/auth'

export interface LoginRequest {
  email: string
  password: string
}

export interface RegisterRequest {
  email: string
  password: string
  name: string
}

export interface AuthResponse {
  user: User
}

interface BackendAuthResponse {
  success: boolean
  data: {
    user: User
  }
}

export const authService = {
  async login(data: LoginRequest): Promise<AuthResponse> {
    const response = await api.post<BackendAuthResponse>('/auth/login', data)
    return {
      user: response.data.data.user,
    }
  },

  async register(data: RegisterRequest): Promise<AuthResponse> {
    const response = await api.post<BackendAuthResponse>('/auth/register', data)
    return {
      user: response.data.data.user,
    }
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout')
  },

  async getProfile(): Promise<User> {
    const response = await api.get<User>('/auth/profile')
    return response.data
  },

  async refreshToken(): Promise<void> {
    await api.post('/auth/refresh')
  },
}
